import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

// Create the regex pattern
const createApiUrlRegex = (domain: string) => {
  const escapedDomain = escapeRegExp(domain);
  const pattern = `^https://${escapedDomain}/api/`;
  return new RegExp(pattern);
};

// If not locahost then init sentry
if (!(location?.hostname === '127.0.0.1') && !(location?.hostname === 'localhost')) {
  Sentry.init({
    environment: window.location.hostname,
    dsn: 'https://aae2619643101fac97962b8c8e784e52@o4506378028908544.ingest.sentry.io/4506378056302592',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: true, // need to review at later point
        maskAllText: false,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      // need to make sure keycloak doesn't end up getting the sentry headers sent to it
      // otherwise cors gets activated
      createApiUrlRegex(window.location.hostname),
      createApiUrlRegex('if.development.finxone.com'),
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'NG0100',
      'ExpressionChangedAfterItHasBeenCheckedError',
      // Browser-speak for a fetch that died from network loss/navigation -
      // same class of noise as the status-0 XHRs dropped in beforeSend
      'TypeError: Load failed',
      'NetworkError when attempting to fetch resource',
    ],
    // Drop expected HTTP failures: 0 = aborted/offline requests, 401 = session
    // expiry (TokenInterceptor handles refresh/login), 503 = server-side outage
    // already visible in backend monitoring. Matches both the ErrorHandlerInterceptor's
    // synthetic "response code: N" errors and Angular's raw "Http failure response" ones.
    beforeSend(event, hint) {
      const ex = hint?.originalException as { status?: number; message?: string } | undefined;
      const message = typeof ex?.message === 'string' ? ex.message : '';
      if (
        [0, 401, 503].includes(ex?.status as number) ||
        /response code: (0|401|503),|Http failure response for .*: (0|401|503)\b/.test(message)
      ) {
        return null;
      }
      return event;
    },
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
